import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <h1 className="text-6xl font-bold text-gray-300 mb-4">404</h1>
      <h2 className="text-xl font-semibold text-gray-700 mb-2">{t('general.page-not-found')}</h2>
      <p className="text-gray-500 mb-6">{t('general.page-not-found-desc')}</p>
      <Link to="/" className="bg-brand-primary text-white font-bold px-6 py-3 rounded-xl hover:bg-brand-primary-hover transition-all">
        {t('general.go-home')}
      </Link>
    </div>
  );
};

export default NotFoundPage;
